import {
    isArray,
    isBoolean,
    isDate,
    isEmpty,
    isError,
    isNaN,
    isNil,
    isNull,
    isNumber,
    isObject,
    isRegExp,
    isString,
    isUndefined,
    omitBy,
    reject,
} from 'lodash';
import {
    FORMATTER_TYPES,
    decimalFormatter,
    logFormatter,
    bitRateFormatter,
    byteFormatter,
    DEFAULT_INVALID_VALUE,
} from './FormattingUtilities';

export const metricDefFormatter = (metricDef) => {
    const units = metricDef.units || '';

    if (metricDef.formatter === FORMATTER_TYPES.BITRATE) {
        return FORMATTER_TYPES.BITRATE;
    }

    if (metricDef.formatter === FORMATTER_TYPES.LOG) {
        return { type: FORMATTER_TYPES.LOG, baseUnits: units };
    }

    if (metricDef.formatter === FORMATTER_TYPES.BYTERATE) {
        return FORMATTER_TYPES.BYTERATE;
    }

    return {
        type: FORMATTER_TYPES.DECIMAL,
        baseUnits: units,
        maxDecimals: metricDef.multiplier === undefined ? 1 : metricDef.multiplier,
        forceDecimals: metricDef.forceDecimals || false,
        ltSymbol: '<',
        ltComparison: 10 ** -metricDef.multiplier,
        ltComparator: (value, config) => value > 0 && value < config.ltComparison,
    };
};

export const formatMetricDefValue = (metricDef, value) => {
    if (!metricDef) return '';
    const units = metricDef.units || '';
    const multiplier = isNil(metricDef.multiplier) ? 1 : metricDef.multiplier;
    const forceDecimals = metricDef.forceDecimals || false;

    if (metricDef.formatter === FORMATTER_TYPES.LOG) {
        return logFormatter(value, { baseUnits: units, multiplier, forceDecimals });
    }

    if (metricDef.formatter === FORMATTER_TYPES.BITRATE) {
        return bitRateFormatter(value);
    }

    if (metricDef.formatter === FORMATTER_TYPES.BYTERATE) {
        return byteFormatter(value);
    }

    if (metricDef.formatter === FORMATTER_TYPES.BYTE) {
        return byteFormatter(value, { forceDecimals });
    }

    const decimalFormatterConfig = {
        type: FORMATTER_TYPES.DECIMAL,
        baseUnits: metricDef.units,
        maxDecimals: metricDef.multiplier === undefined ? 1 : metricDef.multiplier,
        forceDecimals: metricDef.forceDecimals || false,
        ltSymbol: '<',
        ltComparison: 10 ** -metricDef.multiplier,
        ltComparator: (aValue, config) => aValue > 0 && aValue < config.ltComparison,
    };

    return decimalFormatter(value, decimalFormatterConfig);
};

// TODO: Clean up this empty checking code.  I don't really understand what makes a metric 'empty'
//       well enough to clean it up right now...
function isMetricEmpty(value) {
    if (isMetricEmptyIgnoreNegative(value)) {
        return true;
    }

    const valueAsInt = parseInt(value, 10);
    if (valueAsInt === -1) {
        return true;
    }

    return false;
}

function isBlank(x) {
    if (isNumber(x)) return isNaN(x);
    if (isBoolean(x) || isDate(x) || isRegExp(x) || isError(x)) return false;

    let val;

    if (isString(x)) val = x.trim();
    if (isArray(x)) val = reject(x, (xx) => isUndefined(xx) || isNull(xx));
    if (isObject(x)) val = omitBy(x, (xx) => isUndefined(xx) || isNull(xx));

    return isEmpty(val);
}

function isMetricEmptyIgnoreNegative(value) {
    if (isBlank(value)) {
        return true;
    }

    if (value === 'NaN') {
        return true;
    }

    return false;
}

export function formatMos(mos) {
    if (isMetricEmpty(mos)) return DEFAULT_INVALID_VALUE;
    return decimalFormatter(mos, { forceDecimals: true });
}

export function formatSecurityMode(mode) {
    const modeAsInt = parseInt(mode, 10);
    if (modeAsInt === 2) return 'Yes';
    return 'No';
}
